<script setup lang="ts">
  const projectConfig = useProjectConfig();
</script>

<template>
  <span
    v-if="projectConfig.features.almaCookieManager"
    id="alma-cookie-settings"
    data-cc="show-preferencesModal"
    style="display: none"
  >
    {{ $t('BRAND_LINKS.COOKIES.LABEL') }}
  </span>
</template>
